import React from 'react';
import { LogOut, Clock, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { OperationCard } from './OperationCard';

export const CheckOutList = ({
  operations = [],
  onOperationUpdate,
  onConfirm = () => {},
  onEarlyLate = () => {},
  onNoShow = () => {},
  onContact = () => {},
  onAddPayment = () => {},
  loading = false,
  setSelectedRequestForCheckout
}) => {
  const { t } = useTranslation();

  const pendingCount = operations.filter(op => op.operationStatus === 'pending').length;
  const confirmedCount = operations.filter(op => op.operationStatus === 'confirmed').length;

  return (
    <div className="bg-white rounded-xl sm:rounded-2xl p-4 sm:p-6 shadow-sm border border-slate-100">
      {/* Header */}
      <div className="flex items-center justify-between mb-4 sm:mb-6">
        <div className="flex items-center space-x-3 rtl:space-x-reverse">
          <div className="p-2 sm:p-3 bg-orange-100 rounded-xl">
            <LogOut size={20} className="text-orange-600" />
          </div>
          <div>
            <h3 className="text-lg sm:text-xl font-semibold text-slate-900">
              {t('checkOutOperations')}
            </h3>
            <p className="text-sm text-slate-600">
              {operations.length} {t('operations')}
            </p>
          </div>
        </div>
        
        <div className="flex items-center space-x-2 rtl:space-x-reverse text-sm">
          <div className="flex items-center space-x-1 rtl:space-x-reverse">
            <Clock size={14} className="text-yellow-600" />
            <span className="text-yellow-700 font-medium">{pendingCount}</span>
          </div>
          <div className="flex items-center space-x-1 rtl:space-x-reverse">
            <Users size={14} className="text-green-600" />
            <span className="text-green-700 font-medium">{confirmedCount}</span>
          </div>
        </div>
      </div>

      {/* Operations List */}
      <div className="space-y-3 sm:space-y-4">
        {loading ? (
          <div className="space-y-3">
            {[1, 2, 3].map(i => (
              <div key={i} className="animate-pulse">
                <div className="h-24 bg-slate-200 rounded-lg"></div>
              </div>
            ))}
          </div>
        ) : operations.length === 0 ? (
          <div className="text-center py-8">
            <LogOut size={48} className="mx-auto text-slate-300 mb-4" />
            <p className="text-slate-500 text-lg font-medium mb-2">
              {t('noCheckOutsToday')}
            </p>
            <p className="text-slate-400 text-sm">
              {t('noOperationsToday')}
            </p>
          </div>
        ) : (
          operations.map(operation => (
            <OperationCard
              key={operation.id}
              operation={operation}
              onConfirm={onConfirm}
              onEarlyLate={onEarlyLate}
              onNoShow={onNoShow}
              onContact={onContact}
              onAddPayment={onAddPayment}
              setSelectedRequestForCheckout={setSelectedRequestForCheckout}
            />
          ))
        )}
      </div>
    </div>
  );
};